export default __webpack_public_path__ + "static/media/7.d9805a05.png";